import {faClock, faComment, faList, faMoneyBill, faPager, faPhotoVideo, faSignOutAlt, faStoreAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { errorToast } from '../../Toast/Toast'
import Style from './Navbar.module.css'
const Navbar = (props) => {
    const closeMenu=()=>{
        props.setclose()
    }
    const SignOutHandler=()=>{
        closeMenu()
        errorToast('با موفقیت خارج شدین')
        localStorage.removeItem('electronicStepsAdmin')
        window.location.reload()
    }
    return (
        <nav className={props.show?Style.Navbar2:Style.Navbar} >
                <div className={Style.CloseMenu} onClick={closeMenu}><FontAwesomeIcon icon={faTimes}/></div>
                <div className={Style.LogoHolder}><img src="/Assets/Images/Logo/logo.png" alt="آرایشگاه" /></div>
                <ul className={Style.NavHolder}>
                    <li><Link to="/"  onClick={closeMenu}>دوره ها  <FontAwesomeIcon icon={faList}/></Link></li>
                    <li><Link to="/commentlist"  onClick={closeMenu}> نظرات و سوالات <FontAwesomeIcon icon={faComment}/></Link></li>
                    <li><Link to="/accounting"  onClick={closeMenu}>حسابداری <FontAwesomeIcon icon={faMoneyBill}/></Link></li>
                    <li><Link to="/pages"  onClick={closeMenu}>صفحات  <FontAwesomeIcon icon={faPager}/></Link></li>
                </ul>
                <p className={Style.Signout} onClick={SignOutHandler} >خروج <FontAwesomeIcon icon={faSignOutAlt}/> </p>
        </nav>
    )
}

export default Navbar
